import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function PageLayout({ lang, children, onReopenCookies }) {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language !== lang) i18n.changeLanguage(lang);
    document.documentElement.lang = lang === "ar" ? "es" : "en";
  }, [lang, i18n]);

  return (
    <div className="page-shell">
      <Helmet>
        <html lang={lang === "ar" ? "es" : "en"} />
        <title>{t("meta.title")}</title>
        <meta name="description" content={t("meta.description")} />
      </Helmet>
      <Header lang={lang} />
      <main className="main-content" id="top">
        {children}
      </main>
      <Footer lang={lang} onReopenCookies={onReopenCookies} />
    </div>
  );
}
